import { useGetPageSubtitle, useGetPageTitle } from '@/app/store';
import { FC } from 'react';
import { Divider, Flex, Text } from '@chakra-ui/react';

export const PageContent: FC = ({ children }) => {
  const pageTitle = useGetPageTitle();
  const pageSubtitle = useGetPageSubtitle();
  return (
    <>
      <Flex fontSize='sm' p={1} bg='white' justifyContent='space-between'>
        <Flex alignItems='center' overflow='hidden' gap={3}>
          <Text
            fontSize='2xl'
            overflow='hidden'
            whiteSpace='nowrap'
            textOverflow='ellipsis'
            fontWeight='semibold'
          >
            {pageTitle}
          </Text>
          <Text
            fontSize='sm'
            overflow='hidden'
            whiteSpace='nowrap'
            textOverflow='ellipsis'
            color='gray.500'
          >
            {pageSubtitle}
          </Text>
        </Flex>
      </Flex>
      <Divider mb={4} color='gray.400' />
      {children}
    </>
  );
};
